import { isWebview, webviewPostMessage } from "@/utils/webviewUtil";
import { useNavigate } from "react-router-dom";

const OutResource = ({
  children,
  link,
  style = {},
}: {
  children: React.ReactNode;
  link: string;
  style?: React.CSSProperties;
}) => {
  const navigate = useNavigate();
  const isInnerUrl = (url: string) => {
    const host = new URL(url).host;
    return host === window.location.host;
  };

  const clickLink = (url: string) => {
    if (!url) return;
    if (url.startsWith("/")) {
      // 내부 링크
      navigate(url, { replace: true });
    } else if (url.includes(import.meta.env.VITE_APP_MARKET_URL)) {
      window.location.replace(url);
    } else if (isInnerUrl(url)) {
      const navigateUrl = url.split(window.location.host)[1];
      navigate(navigateUrl, { replace: true });
    } else {
      if (isWebview()) {
        const pathname = url.split("moreden.co.kr")[1];
        const isMoreden =
          url.includes("https://moreden.co.kr") ||
          url.includes("https://www.moreden.co.kr") ||
          url.includes("https://dev.moreden.co.kr") ||
          url.includes("https://www.dev.moreden.co.kr");
        !isMoreden
          ? webviewPostMessage("router:push", {
              viewType: "inAppBrowser",
              url: url,
              title: "",
              height: 0.9,
              enableRefresh: false,
            })
          : navigate(pathname);
      } else {
        window.open(url, "_blank");
      }
    }
  };

  return (
    <div onClick={() => clickLink(link)} style={style}>
      {children}
    </div>
  );
};

export default OutResource;
